/* cfg scripts v1.1.114 */

/* accordion toggle tabs */
$('.accourdion_toggle').click(function(e) {
  	e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('showinner')) {
        $this.next().removeClass('showinner');
      	$this.removeClass('openedToggle');
    } else {
        //$this.parent().parent().find('.accourdion_item .inner').removeClass('showinner');
        //$this.parent().parent().find('.accourdion_toggle').removeClass('openedToggle');
      	$this.toggleClass('openedToggle');
        $this.next().toggleClass('showinner');
    }
});
/* accordion toggle tabs */


/* sizes guide popup modal */
if ($("body").hasClass("template-product")) {

  	var sizeGudieLink = $('.pd_inner').find('a');
  	sizeGudieLink.each(function() {
        var currentElement = $(this);
        var currentElementText = currentElement.text();
        if (currentElementText == "Size Guide") {
            if ( currentElement.parents('.pdi_sections').hasClass('pdi_sections-bundle') ) {
              	$currentID = currentElement.parents('.BundleFlexRight').find('#variant-select').attr('data-pid');
				currentElement.removeClass('size_popup').addClass('size_popup-bundle').removeAttr("href").attr('data-mlid', $currentID);
            } else {
				currentElement.addClass('size_popup').removeAttr("href");
            }
        }
    });
}

var sgOpen = $(".size_popup, .pd_inner_popuplink");
var sgModal = $(".sg_modal");
var sgClose = $(".modal_back, .modal_close");
sgOpen.click(function(){
  sgModal.css("display", "block");
});
sgClose.click(function(){
  sgModal.css("display", "none");
});

//for bundle popup
$sgOpenB = $(".size_popup-bundle");
$sgModalB = $(".sg_modal-bundle");
$sgCloseB = $(".modal_back, .modal_close");

$sgOpenB.each(function() {
    $(this).click(function(){
        $sgOpenID = $(this).attr('data-mlid');
      	$(this).parents('.BundleFlexRight').find('.sg_modal-bundle').css("display", "block");
    });
});


$sgCloseB.click(function(){
  $sgModalB.css("display", "none");
});
/* sizes guide popup modal */


/* closer look */
$(document).ready(function(){

  	$.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop() - 100;
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom /*|| elementBottom < viewportBottom*/;
    };
  /*
    $(window).on('scroll', function() {
      $('.pdcl_text').each(function() {
        if ($(this).isInViewport()) {
          $(this).addClass('isvisible');
        } else {
          $(this).removeClass('isvisible');
        }
      });
    });
  */
    
});
/* closer look */

/* related products see more button */
var numRltdPrdct = $('.cfg_giu .product-grid-item').length
if (numRltdPrdct < 7) {
	$('.smp_button').hide();
}

if (screen.width < 1023) {
	$(".cfg_giu .product-grid-item").hide();
	$(".cfg_giu .product-grid-item:lt(4)").show();
} else {
	$(".cfg_giu .product-grid-item").hide();
	$(".cfg_giu .product-grid-item:lt(6)").show();
}
$('.smp_button').click(function(e) {
  	e.preventDefault();
  	if ($(this).hasClass('smp_button_less')) {
    	$(this).removeClass("smp_button_less").text("See More Products");
      	$('html, body').animate({
          	scrollTop: $(".wrapper.cfg_wpr.product__related").offset().top
        }, 300);
      	if (screen.width < 1023) {
          		$(".cfg_giu .product-grid-item").hide();
          		$(".cfg_giu .product-grid-item:lt(4)").show();      
        } else {
                $(".cfg_giu .product-grid-item").hide();
          		$(".cfg_giu .product-grid-item:lt(6)").show();      
        }
    } else {
      $(".cfg_giu .product-grid-item").show();
      $(this).addClass("smp_button_less").text("See Less Products"); 

    }
});
/* related products see more button */





